import {ServiceBase} from "../ServiceBase";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {CGPEventSubscription} from "../sdk/cgp-sdk.interface";
import {IFirebaseToasterService, IUCCToasterParams, TOAST_TYPES} from "./firebase-toaster.service.interface";
import {Check, TimeSpan} from "@sparkware/app-utils";
import {safeJsonParse} from "../../../utils/json-helper";
import {GameInfo} from "../games/game-info";
import {GameModeEnum} from "../game-runner/interfaces/game-context/game-context-view-model.interface";
import {IStandardToastDefinition} from "./toaster.service.interface";

export class FirebaseToasterService extends ServiceBase implements IFirebaseToasterService {
    private _receivedToasterEvent: CGPEventSubscription;
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this.reaction(() => this.services.user.isAuthorized, (isAuthorized) => {
            if(isAuthorized) {
                this._receivedToasterEvent = this.services.sdk.events.onReceivedToaster(this.onToastMessageReceived);
            } else {
                this._receivedToasterEvent?.off();
            }
        }, {
            fireImmediately: true
        });

        // makeObservable(this);
    }

    /**
     * Translates the parameters received through firebase to what the wrapper uses ( shorter property names mostly )
     * @param params (Array) -> Message parameters received from firebase
     */
    private onToastMessageReceived = async (params: IUCCToasterParams[]) => {
        // this was added for qa as an alternative to firebase ( in case of firebase received messages, this condition is redundant )
        if (!this.services.user.isAuthorized) {
            this.services.logger.debug('TOASTER [onToastMessageReceived] :: NOT LOGGED IN, QUITTING');
            return;
        }

        for (let i = 0; i < params.length; i++) {
            // translate firebase message params to toast data
            const config = params[i];

            // let's see if the toast is about a game
            const metaData = Check.isNullOrUndefined(config.MetaDataParams) ? {} : safeJsonParse(config.MetaDataParams, {});
            const gameTypeIDRaw = metaData.GameTypeID || config.GameTypeID;
            let gameInfo: GameInfo | undefined = undefined;
            if (!Check.isNullOrUndefined(gameTypeIDRaw)) {
                const GameTypeIDInt = parseInt(gameTypeIDRaw);
                if (isNaN(GameTypeIDInt) ) {
                    throw new Error("We got a game type id but it could not be converted to string");
                }
                gameInfo = await this.services.games.getUnrestrictedGameInfo(GameTypeIDInt);
            }

            const timeout: number = config.DurationInSec || 0;

            // we build the toast data. some of the data is for the content, some for analytics
            const toastData: IStandardToastDefinition = {
                id: config.MessageID,
                // type: config.Type,
                // IToastOptions
                toastOptions: {
                    timeout: TimeSpan.fromSeconds(timeout)
                },
                // IStandardToastContentProps
                contentProps: {
                    title: config.Title,
                    message: config.SubTitle,
                    button: undefined,
                    image: (this.services.mediaQuery.mAndBelow ? config.MobileImage : config.PCImage) || config.IconImagePath,
                },
                onToastShown: () => {
                    if (!Check.isEmpty(config.analyticsData)) {
                        this.services.analytics.sendAnalytics(config.analyticsData?.category, config.analyticsData?.action, config.analyticsData?.label);
                    }
                }
                // showImageByDefault: config.ShowDefaultImage,

                // TODO: This data seems unused. Verify this
                // customUIConfig: config.customUIConfig,
                // responseTopicPath: config.ResponseTopicPath,
                // close: config.close,
                // layout: config.layout,
            };


            if (gameInfo) {
                // toastData.type = TOAST_TYPES.ACTION;
                toastData.contentProps.button = {
                    text: config.buttonText || this.services.translation.translate("PLAY"),
                    onClick: (closeToast) => {
                        if(gameInfo) {
                            this.services.gameRunner.then(gameRunner => {
                                gameRunner.openGame({gameInfo, gameMode: GameModeEnum.Real});
                            })

                        }
                        closeToast();
                    }
                };
            } else if (config.buttonText && config.callback) {
                toastData.contentProps.button = {
                    text: config.buttonText,
                    onClick: (closeToast) => {
                        config.callback();
                        closeToast();
                    },
                };
            } else if (config.Type === TOAST_TYPES.ACKNOWLEDGE || (!config.Type && !timeout)) {
                // we show by default an OK button if Type is Ackowledge or if Type and timeout are not set
                toastData.contentProps.button = {
                    text: this.services.translation.translate("OK"),
                    onClick: (closeToast) => {
                        closeToast();
                    },
                };
            }

            this.services.toaster.showStandardToast(toastData);
        }
    }

}